import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AbilityConfig } from '../ability-config/ability-config';
import { PlatformLocation } from '@angular/common';
import { TokenService } from '../tokenService.service';
var CasePracticeCommunicateListComponent = (function () {
    function CasePracticeCommunicateListComponent(commonService, platformLocation, apiService, route, tokenService, router) {
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.apiService = apiService;
        this.route = route;
        this.tokenService = tokenService;
        this.router = router;
        this.showMoment = false;
        //进入新能力考核标识
        this.version = 0;
        this.isOpenClass = 0;
        this.isShowQuestionnaire = false;
        this.questionnaireInfo = null;
        this.approachTheme = {};
        this.currentIndex = 0;
        this.isShowApproach = false;
        this.isCustomLock = false;
        this.isTencent = false; // 是否腾讯对接
        this.lock = false;
        this.isShowToast = false;
    }
    Object.defineProperty(CasePracticeCommunicateListComponent.prototype, "showGoToSurveyBtn", {
        get: function () {
            if (Array.isArray(this.practiceList)) {
                return this.practiceList.every(function (item) {
                    return item.status === 2;
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    CasePracticeCommunicateListComponent.prototype.ngOnInit = function () {
        var _this = this;
        // if(!localStorage.getItem('openClass')){
        //   this.isOpenClass = this.platformLocation['location']['href'].indexOf('isShowBack') > -1 ? 1: 0;
        //   localStorage.setItem('openClass',String(this.isOpenClass));
        // }else{
        //   this.isOpenClass = Number(localStorage.getItem('openClass'));
        // }
        // ---Stephen add 2025-03-07---
        // 添加是否腾讯对接的判断
        this.isTencent = this.commonService.checkAndSetModuleId();
        console.log(this.isTencent, '🐏🐏🐏🐏🐏🐏');
        // -------------------------------------------------------------------
        localStorage.setItem('moduleId', '3');
        this.route.params.subscribe(function (params) {
            var isOutLink = Number(params['isOutLink']);
            if (_this.platformLocation['location']['href'].indexOf('isShowBack') !== -1 || isOutLink === 1) {
                localStorage.setItem('openClass', '1');
            }
            else {
                localStorage.removeItem('openClass');
            }
            _this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        });
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.projectId = localStorage.getItem('projectId');
        var projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
        if (this.projectId && projectmsg) {
            projectmsg.map(function (item) {
                if (item.type == 4 && item.lockType == 1) {
                    _this.lock = item.lock;
                    _this.promptText = "\u80FD\u529B\u8003\u6838\u5C06\u4E8E" + item.promptTime + "\u5F00\u653E\u3002";
                }
            });
        }
        this.getPracticeList();
    };
    //获取进度
    CasePracticeCommunicateListComponent.prototype.getProgress = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
        }).toPromise();
    };
    CasePracticeCommunicateListComponent.prototype.getPracticeList = function () {
        var _this = this;
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        this.route.params.subscribe(function (params) {
            _this.exerciseMetaId = params['exerciseMetaId'];
            _this.getLearningTour().then(function (result) {
                _this.learningPathMetas = result.learning_path_metas;
                _this.userId = result.user_id;
            }).then(function () {
                return _this.createAndGetPracticeList(_this.exerciseMetaId, _this.userId).then(function (result) {
                    return _this.exerciseList = result;
                });
            }).then(function () {
                // this.learningPathMetaId = 302;
                return _this.getLearningPathMetaId(_this.exerciseList.learningPathId).then(function (result) {
                    return _this.learningPathMetaId = result.data;
                });
            }).then(function () {
                return _this.commonService.getCustomLockDate(_this.learningPathMetaId).then(function (result) {
                    return _this.learningPath = result;
                });
            }).then(function () {
                _this.getlearningInit(_this.exerciseList.practiceMetaId, _this.exerciseList.exercise);
                _this.getListItemExtends(_this.exerciseList.exercise);
            }).then(function () {
                return _this.getProgress(_this.learningPathMetaId).then(function (result) {
                    //向LMS传递进度
                    if (localStorage.getItem('source_env') === 'LMS_SCORM') {
                        _this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', result[0].progressList[0].progress, 'data');
                    }
                    return _this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'];
                });
            }).then(function () {
                return _this.getPracticeMoments(_this.exerciseMetaId, _this.userId).then(function (result) {
                    return _this.moments = result;
                });
            }).then(function () {
                $('#userIdContainer').val(_this.userId);
                $('#learningPathMetaIdContainer').val(_this.learningPathMetaId);
                _this.learningPathId = _this.exerciseList.learningPathId;
                _this.practiceList = _this.exerciseList.exercise;
                _this.practiceId = _this.exerciseList.id;
                _this.approachTheme.colorSystem = 'dark';
                _this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
                _this.approachTheme.currentIndex = _this.currentIndex - 2;
                _this.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
                _this.approachTheme.btnTxt = '开启能力考核';
                _this.practiceList[0].momentsList = _this.handleMomentsList(_this.moments);
            }).then(function () {
                //增加学习断点
                _this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(_this.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': _this.platformLocation['location']['href'], 'projectId': localStorage.getItem('projectId') ? localStorage.getItem('projectId') : null }).then();
                _this.commonService.setCustomLockDate(_this.learningPath, Date());
                _this.isCustomLock = _this.learningPath.subItems[3].isLock;
                _this.isShowApproach = true;
            });
        });
    };
    CasePracticeCommunicateListComponent.prototype.linkToError = function (status) {
        var link = ['error', status];
        this.router.navigate(link);
    };
    CasePracticeCommunicateListComponent.prototype.createAndGetPracticeList = function (exerciseMetaId, userId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sim/v1/simulation/' + exerciseMetaId + '/createAndGet'
            // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/createAndGet?userId=' + userId
        }).toPromise();
    };
    CasePracticeCommunicateListComponent.prototype.getPracticeMoments = function (exerciseMetaId, userId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sim/v1/simulation/' + exerciseMetaId + '/achievement/list'
            // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/achievement/list?userId=' + userId
        }).toPromise();
    };
    //获取learningpathid
    CasePracticeCommunicateListComponent.prototype.getLearningPathMetaId = function (learningPathId) {
        return this.apiService.ajax({
            'type': 'get',
            // 'url': this.commonService.getOrigin() + '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
            'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
        }).toPromise();
    };
    CasePracticeCommunicateListComponent.prototype.getCardIdWithUserId = function (exerciseMetaId, userId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sim/v1/simulation/' + exerciseMetaId + '/currentCard',
        }).toPromise();
    };
    CasePracticeCommunicateListComponent.prototype.handleMomentsList = function (moments) {
        var arr = [];
        if (moments) {
            moments.forEach(function (v) {
                arr.push('moments' + v.yySimulationAchievementMeta.exerciseMetaId + '-' + v.yySimulationAchievementMeta.id);
            });
        }
        return arr;
    };
    CasePracticeCommunicateListComponent.prototype.getlearningInit = function (practiceMetaId, practiceList) {
        var _this = this;
        var temp = true;
        this.abilityConfig.getOnceinoByPracticeMetaId(practiceMetaId).subscribe(function (result) {
            _this.finishStatus = result == 1 ? true : false;
            for (var i = 0; i <= practiceList.length - 1; i++) {
                if (practiceList[i].status != 2) {
                    temp = false;
                }
            }
            _this.finished = temp;
            _this.getUserLearningPathMetaId();
        });
    };
    CasePracticeCommunicateListComponent.prototype.getListItemExtends = function (practiceList) {
        //loadconfig
        this.apiService
            .loadConfig('./assets/config/practiceList.json')
            .subscribe(function (result) {
            practiceList.forEach(function (item, index) {
                console.log(result[item.title]);
                if (result[item.title]) {
                    item['extends'] = result[item.title];
                }
            });
        });
    };
    CasePracticeCommunicateListComponent.prototype.getLearningTour = function () {
        return this.apiService.ajax({
            type: 'get',
            url: '/sr/learningtournew'
        }).toPromise();
    };
    //获取用户学习 metaid and version
    CasePracticeCommunicateListComponent.prototype.getUserLearningPathMetaId = function () {
        var that = this;
        that.getOrCreateLearningPath(String(that.learningPathMetaId)).then(function (result) {
            that.learningPath = result;
            that.learningPathSubItems = result.subItems;
            if (result.lock !== 3) {
                that.goPostSurveyFlag = true;
            }
            else {
                that.goPostSurveyFlag = false;
            }
        }).then(function () {
            return that.getUserQuestionnaireInfo(that.learningPathMetaId).then(function (result) {
                return that.questionnaireInfo = result;
            });
        }).then(function () {
            console.log(that.isShowQuestionnaire);
            that.isShowQuestionnaire = that.questionnaireInfo && that.questionnaireInfo.length === 0 && that.learningPathSubItems.filter(function (d) { return d.type === 3; })[0].progress === 100 && that.learningPathSubItems.filter(function (d) { return d.type === 4; })[0].progress !== 100;
        });
    };
    CasePracticeCommunicateListComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
    };
    CasePracticeCommunicateListComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            backgroundColor: 'white',
        });
    };
    CasePracticeCommunicateListComponent.prototype.goToNextStep = function (practiceItem) {
        var _this = this;
        var practiceIdx = {
            20201: 0,
            40201: 0,
        }[Number(practiceItem.exerciseMetaId)];
        // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(practiceIdx+1)}).then();
        if (practiceItem.status === 2) {
            this.getCardIdWithUserId(this.exerciseMetaId, this.userId).then(function (result) {
                if (_this.isOpenClass === 0) {
                    var link = ['egret-practice-communicate-report', _this.exerciseMetaId, result.id];
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                }
                else {
                    var link = ['egret-practice-communicate-report', _this.exerciseMetaId, result.id, 'isShowBack=0'];
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                }
            });
        }
        else {
            if (this.learningPathMetaId) {
                var channel = document.getElementById('resource_route');
                var origin = channel.dataset.src === '' ? this.commonService.getOrigin() : 'https://m.transtalent.cn';
                var params = channel.dataset.src === '' ? '' : '&channelHost=' + this.commonService.getOrigin() + '/yyddi/';
                var href = origin + '/communicate/' + this.exerciseMetaId + '/index.html?userId=' + this.userId + '&learningPathMetaId=' + this.learningPathMetaId + '&simulationId=' + this.exerciseMetaId + '&token=' + this.tokenService.findToken() + '&userIdEncoder=' + this.tokenService.findUserIdEncoder();
                this.platformLocation['location']['href'] = this.isOpenClass === 1 ? href + '&isShowBack=0' : this.type === 'huatek' ? href + '&type=huatek' : href + params;
            }
            else {
                this.getLearningPathMetaId(this.learningPathId).then(function () {
                    _this.goToNextStep(practiceItem);
                });
            }
        }
    };
    //展示难忘瞬间gallary
    CasePracticeCommunicateListComponent.prototype.momentView = function (mlist, $event) {
        this.showMoment = true;
        this.momentList = mlist;
        $event.stopPropagation();
    };
    //关闭难忘瞬间gallary
    CasePracticeCommunicateListComponent.prototype.momentExit = function () {
        this.showMoment = false;
    };
    CasePracticeCommunicateListComponent.prototype.goToPostSurvey = function () {
        if (this.type === 'huatek') {
            this.commonService.sendPostMessage(1, 'goPostSurvey');
            return;
        }
        else {
            if (this.lock) {
                this.showToast();
                return;
            }
            this.apiService
                .ajax({
                type: 'GET',
                url: '/sr/exposeoutapi/setAbilitySession/' +
                    this.learningPathMetaId +
                    '/4',
            })
                .subscribe(function (result) {
            });
            this.commonService.learningPortEventLogByCandy({ 'learningPathMetaId': this.learningPathMetaId, 'module': '情景模拟', 'btnName': this.approachTheme.btnTxt, 'userId': localStorage.getItem('userId') }).then();
            var link = ['ability-survey', this.learningPathMetaId, 2];
            this.router.navigate(link);
        }
    };
    CasePracticeCommunicateListComponent.prototype.showToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    CasePracticeCommunicateListComponent.prototype.finish = function () {
        if (this.finishStatus) {
            return;
        }
        else {
            this.abilityConfig
                .setOnceinoByPracticeMetaId(this.practiceMetaId)
                .subscribe();
            var link = ['learning-map'];
            this.router.navigate(link);
        }
    };
    CasePracticeCommunicateListComponent.prototype.close = function () {
        var link = ['learning-path', this.learningPathMetaId];
        this.router.navigate(link);
    };
    CasePracticeCommunicateListComponent.prototype.closeQuestionnaire = function () {
        this.isShowQuestionnaire = false;
    };
    //查询用户相应能力满意度
    CasePracticeCommunicateListComponent.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        }).toPromise();
    };
    return CasePracticeCommunicateListComponent;
}());
export { CasePracticeCommunicateListComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-communicate-list/case-practice-communicate-list.component.ts.pre-build-optimizer.js